import React, { Component } from "react";
import AlphaLogo from "../../img/alpha-logo-neu-with-text.png";
// import AlphaLogoSmall from '../../img/logo-black.png';
import { FormattedMessage, injectIntl } from "react-intl";

// import {FaBook} from 'react-icons/fa';
import { Link, withRouter } from "react-router-dom";
import { classes } from "../../functions/utils";

// GLOBALS
import AA_GLOBAL from "../../globals/globals";
import { forgetSession } from "../../functions/authSession";
import { DIY_PATH_MARKER } from "../../globals/constants";

// REDUX
import { connect } from "react-redux";
import { logout, setUserRole } from "../../actions/userActions";
import UserSection from "./UserSection";
import NavSelect from "../inputs/NavSelect";

class MainHeaderNav extends Component {
  state = {
    pagesMenuVisible: false,
    blockOptions: false,
    renderInfoPagesBtn: true,
  };

  UNSAFE_componentWillMount() {
    if (this.props.user && this.props.user.roles) {
      this.setTheUserRoleMenu(this.props);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.roles) {
      this.setTheUserRoleMenu(nextProps);
    }
  }

  componentDidMount() {
    this.toggleInfoBtn();
    this.handleScroll();

    document.addEventListener("mouseup", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this.handleClickOutside);
    window.removeEventListener("resize", this.toggleInfoBtn);
  }

  setTheUserRoleMenu = props => {
    const modules = props.info.apps[this.props.info.default_app].modules;

    const { labels, roles, role_selected } = this.props.user;
    // only display those for which a module exists
    const rolesMenu = roles.filter(r => modules[r]);

    let selectedRoleItem;
    const formattedMenu = rolesMenu.map((roleKey, index) => {
      const item = { id: index, key: roleKey, label: labels[roleKey] };
      if (roleKey === role_selected) selectedRoleItem = item;
      return item;
    });

    this.setState({
      userRoleMenu: AA_GLOBAL.withEditorItem(formattedMenu, this.props.user, this.props.intl),
      selectedRoleItem,
    });
  };

  isLoggedIn = () => (this.props.user && this.props.user.roles ? true : false);

  // Only alpha-awards.com staff and users with the diy module assigned may
  // jump into the editor from the test-environment hint.
  canUseEditor = () => {
    const { user } = this.props;
    if (!user) return false;
    return (
      (typeof user.email === "string" && user.email.endsWith("@alpha-awards.com")) ||
      (Array.isArray(user.roles) && user.roles.includes("diy"))
    );
  };

  get publicLinks() {
    return (
      this.props.info &&
      this.props.info.content_pages &&
      this.props.info.content_pages.filter(c => !c.slug.includes("auth"))
    );
  }

  // add click (mousedown) event on the document
  // when documet is clicked - hide menu
  handleClickOutside = e => {
    if (this.state.pagesMenuVisible) {
      this.setState({ pagesMenuVisible: false });
    }
  };

  // show user dropdown navigation
  showMenu = () => {
    this.setState({ pagesMenuVisible: true });
  };

  logoutUser = () => {
    forgetSession();
    this.props.logout();
    this.props.history.push("/ui/auth");
    document.querySelector("body").classList.remove("theme-1");
  };

  toggleInfoBtn = e => {
    const screenWidth = this.getScreenWidth();

    // on desktop size
    if (screenWidth > 1280) {
      // not logged in
      if (!this.isLoggedIn()) {
        if (this.publicLinks?.length < 4) this.setState({ toggleInfoBtnClass: "hide" });
      }
    } else {
      // if not logged in
      if (!this.isLoggedIn()) {
        this.setState({ toggleInfoBtnClass: "show" });
      }
    }

    // if(this.props.info.content_pages.length === 0) this.setState({toggleInfoBtnClass: "hide" })
  };

  handleScroll = () => {
    window.addEventListener("resize", this.toggleInfoBtn);
  };

  getScreenWidth = () =>
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  render() {
    const showAlphaLogo = this.props.info.apps?.[this.props.info.default_app]?.show_alpha_logo;

    return (
      <div className={`mainHeaderNav`}>
        <Link to="/ui/" test="logoLink">
          {showAlphaLogo ? (
            <span className="mainHeaderNav__logoPlaceholder" aria-hidden="true" />
          ) : (
            <img
              src={AlphaLogo}
              title="Home"
              alt="alpha awards logo"
              data-test="logo"
              className="mainHeaderNav__logo"
            />
          )}
          {/*<img src={AlphaLogoSmall} alt="alpha awards" className="mainHeaderNav__logoSmall"/>*/}
        </Link>

        {this.props.info &&
        this.props.info.is_test_environment &&
        !window.location.pathname.includes(DIY_PATH_MARKER) ? (
          <div className="mainHeaderNav__testEnvAlert">
            <div>
              <strong><FormattedMessage id="testEnvironmentTitle" /></strong>
              {" — "}
              <FormattedMessage id="testEnvironmentDescription" />
            </div>
            {this.canUseEditor() && (
              <a href="/diy" className="mainHeaderNav__testEnvAlert-btn">
                <FormattedMessage id="editor" />
              </a>
            )}
          </div>
        ) : null}

        {/* Print this info to avoid mistakes during development. */}
        {/* {process.env.NODE_ENV === "development" && AA_GLOBAL.baseURL && (
          <span>Connected to backend: "{AA_GLOBAL.ba3:seURL}"</span>
        )} */}

        <nav role="navigation" className="mainHeaderNav__nav" style={{ paddingRight: "1rem" }}>
          <ul className="mainHeaderNav__nav-items">
            {!this.isLoggedIn() && this.publicLinks && this.publicLinks.length <= 3 && (
              <li>
                <ul className="mainHeaderNav__nav-links">
                  {this.publicLinks.map((item, index) => (
                    <li key={index}>
                      <a href={`/ui/page/${item.slug}`}>{item.title}</a>
                    </li>
                  ))}
                  {/* {this.props.info.content_pages.length !== 0 &&
                this.props.info.content_pages.length <= 3 && */}
                  <li>
                    <a href="/ui/auth">
                      <FormattedMessage id="login" />
                    </a>
                  </li>
                  {/* } */}
                </ul>
              </li>
            )}

            {/* {this.props.user.current_role === "submission_admin" && (
              <li>
                <a
                  href="/configuration"
                  aria-label={this.props.intl.formatMessage({ id: "edit" })}
                  className="button__nav"
                  activeClassName="button__nav--active"
                >
                  <IconAria iconId="edit" className="mainHeaderNav__icon" />
                </a>
              </li>
            )} */}
            {/* <li>

              <NavLink
                to="/ui/info"
                aria-label={this.props.intl.formatMessage({ id: "info" })}
                className="button__nav"
                activeClassName="button__nav--active"
              >
                <IconAria iconId="info" className="mainHeaderNav__icon" />
              </NavLink>
            </li> */}

            {
              <li onClick={this.showMenu} data-test="userBtn">
                <span
                  onKeyDown={e => e.key === "Enter" && this.showMenu()}
                  data-menu
                  tabIndex="0"
                  className={`button__nav mainHeaderNav__user mainHeaderNav__info
                ${this.state.toggleInfoBtnClass}`}
                >
                  <FormattedMessage id="info" />
                  {/* <IconAria iconId="info" className="mainHeaderNav__icon" /> */}
                  <span className="mainHeaderNav__user-name" data-menu></span>
                  {/* <span data-menu className="mainHeaderNav__user-arrow">
                  <IconAria iconId="arrowDown" data-menu />
                </span> */}
                  <ul
                    data-menu
                    className={classes(
                      "mainHeaderNav__user-menu",
                      this.state.pagesMenuVisible ? "" : "mainHeaderNav__user-menu-hide"
                    )}
                  >
                    {this.isLoggedIn() && !this.props.user.enforce_profile && (
                      <li>
                        <a
                          href={`/ui/${this.state.selectedRoleItem.key}/info`}
                          className="mainHeaderNav__user-menu-a"
                        >
                          <FormattedMessage id="info" />
                        </a>
                      </li>
                    )}
                    {this.isLoggedIn() && this.props.user.enforce_profile && (
                      <li>
                        <a href={`/ui/page/info`} className="mainHeaderNav__user-menu-a">
                          <FormattedMessage id="info" />
                        </a>
                      </li>
                    )}

                    {this.isLoggedIn() &&
                      !this.props.user.enforce_profile &&
                      this.publicLinks &&
                      this.publicLinks.map((link, index) => (
                        <li key={index}>
                          <a
                            href={`/ui/${this.state.selectedRoleItem.key}/page/${link.slug}`}
                            className="mainHeaderNav__user-menu-a"
                          >
                            {link.title}
                          </a>
                        </li>
                      ))}
                    {(!this.isLoggedIn() || (this.isLoggedIn && this.props.user.enforce_profile)) &&
                      this.publicLinks &&
                      this.publicLinks.map((link, index) => (
                        <li key={index}>
                          <a href={`/ui/page/${link.slug}`} className="mainHeaderNav__user-menu-a">
                            {link.title}
                          </a>
                        </li>
                      ))}

                    {this.props.user && !this.props.user.roles && (
                      <li>
                        <a href="/ui/auth" className="mainHeaderNav__user-menu-a">
                          <FormattedMessage id="login" />
                        </a>
                      </li>
                    )}
                  </ul>
                </span>
              </li>
            }

            {this.state.userRoleMenu && this.state.userRoleMenu.length > 1 && (
              <li>
                <NavSelect
                  options={this.state.userRoleMenu}
                  blockOptions={true}
                  addClass="mainHeaderNav__nav-role"
                  select={[this.state.selectedRoleItem]}
                  getValues={val => {
                    AA_GLOBAL.switchUserRole(val[0].key, this.props);
                    // window.location.reload();
                  }}
                />
              </li>
            )}

            {/* <li><a href="#empty" className="button button__nav button__nav--alert"><MdEmail className="mainHeaderNav__icon"/></a></li>
            <li>
              <NavLink
                to={`/ui/cart`}
                className="button__nav button__nav--alert"
                activeClassName="button__nav--active"
                test="cartLink"
                exact={true}>
                <MdShoppingCart className="mainHeaderNav__icon"/>
              </NavLink>
            </li> */}
            {this.isLoggedIn() && (
              <li>
                <UserSection />
              </li>
            )}
          </ul>
        </nav>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  user: store.user,
  info: store.app.info,
});

export default injectIntl(
  connect(mapStateToProps, { logout, setUserRole })(withRouter(MainHeaderNav))
);
